"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcParser = void 0;
class RpcParser {
    isError(response) {
        return 'error' in response;
    }
}
exports.RpcParser = RpcParser;
